/** Shared markup for admin status / approval dialogs (Activity, Event, Attraction, Package, Rental). */

export const STATUS_DIALOG_WIDTH = "w-[400px]";

export const getApprovalStatusColor = (value) => {
  switch (Number(value)) {
    case 0:
      return "text-yellow-600 bg-yellow-50";
    case 1:
      return "text-green-600 bg-green-50";
    case 2:
      return "text-red-600 bg-red-50";
    default:
      return "text-gray-600 bg-gray-50";
  }
};

const toggleTrackClass =
  "w-11 h-6 bg-gray-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-primary/20 rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-primary";

export const StatusSettingsBody = ({ children }) => (
  <div className="p-4 space-y-4">{children}</div>
);

export const StatusToggleRow = ({ title, description, checked, onChange }) => (
  <div className="flex items-center justify-between p-3 bg-gray-50 rounded-lg">
    <div>
      <h3 className="text-sm font-medium text-gray-700">{title}</h3>
      <p className="text-xs text-gray-500">{description}</p>
    </div>
    <label className="relative inline-flex items-center cursor-pointer">
      <input
        type="checkbox"
        className="sr-only peer"
        checked={Boolean(checked)}
        onChange={onChange}
      />
      <div className={toggleTrackClass} />
    </label>
  </div>
);

export const StatusApprovalSection = ({
  value,
  onChange,
  description = "Approve / reject this item",
}) => (
  <div className="p-3 bg-gray-50 rounded-lg space-y-2">
    <div>
      <h3 className="text-sm font-medium text-gray-700">Approval Status</h3>
      <p className="text-xs text-gray-500">{description}</p>
    </div>
    <select
      value={value}
      onChange={(e) => onChange(Number(e.target.value))}
      className={`w-full px-3 py-2 rounded-lg border border-gray-200 text-sm font-medium focus:outline-none focus:ring-2 focus:ring-primary/20 ${getApprovalStatusColor(
        value
      )}`}
    >
      <option value={0} className="text-yellow-600 bg-white">
        Pending Review
      </option>
      <option value={1} className="text-green-600 bg-white">
        Approved
      </option>
      <option value={2} className="text-red-600 bg-white">
        Rejected
      </option>
    </select>
  </div>
);
